
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import {} from "@newview/ui";
@Component({
  name: "mainSubMenu",
  components: {},
})
export default class mainSubMenu extends BaseVue {
  @Prop({ default: () => [] }) subMenu!: Array<any>; //菜单数据
  @Prop({ default: () => "vertical" }) mode!: any; //菜单数据
  @Prop({ default: () => true }) isShowIcon!: any; // 菜单icon显示

  mounted() {
    console.log(this.subMenu);
  }
}
